// eslint-disable-next-line import/prefer-default-export
export enum AspectRatio {
  '16:9' = '16:9',
  '9:16' = '9:16',
  '1:1' = '1:1',
  '4:3' = '4:3',
  '4:5' = '4:5',
}
